module.exports = __webpack_public_path__ + "img/美团_01.8874e943.jpg";